import { z } from 'zod';

export const relatedCredentialsSchema = z.object({
  relatedCredentials: z
    .array(z.object({ value: z.string() }))
    .max(6, 'Cannot have more than 6 items')
    .optional(),
});
